import React, { useState, useEffect } from 'react';
import clinicService from '../../../../../services/clinic.service';
import { useParams } from 'react-router-dom';
import NewReputation from './NewReputation';
import Links from './Links';
import CommentsTable from './CommentsTable';
import FeedbackTable from './FeedbackTable';
import Loading from '../../../../common/Loading';
function ReputationTab() {
    const { clinicId } = useParams();
    const [hasReputationService, setHasReputationService] = useState(false);
    const [shortCode, setShortCode] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        checkReputationService();
    }, [clinicId]);

    const checkReputationService = () => {
        setLoading(true);
        clinicService
            .getReputationClinic(clinicId)
            .then((res) => {
                setShortCode(res.data.shortCode);
                setHasReputationService(true);
            })
            .catch(() => {
                setHasReputationService(false);
            })
            .finally(() => {
                setLoading(false);
            });
    };

    const copyShortCode = () => {
        if (shortCode) {
            navigator.clipboard.writeText(shortCode);
        }
    };

    if (loading) {
        return <Loading />;
    }

    return (
        <>
            <div className="d-flex align-items-end justify-content-between gap-2 mb-3">
                <div>
                    <h5 className="reputation__title mb-1">
                        <i className="bi bi-star-fill text-primary me-1"></i>
                        Reputation Enhancement
                    </h5>
                    <p className="text-muted small mb-0">Manage reputation links, patient comments, and feedback.</p>
                </div>
            </div>

            {!hasReputationService ? (
                <NewReputation clinicid={clinicId} checkReputationService={checkReputationService} />
            ) : (
                <div className="d-flex flex-column gap-3">
                    <div className="notifications-panel">
                        <div className="notifications-panel__header">
                            <i className="bi bi-link-45deg"></i>
                            Short Code
                        </div>
                        <div className="notifications-panel__body">
                            <p className="notifications-form-hint mb-3">
                                Used in your reputation URLs, e.g. https://eyeconx.com/{shortCode}
                            </p>
                            <div className="notifications-url-box">
                                <code>{shortCode}</code>
                                <button type="button" className="notifications-copy-btn" onClick={copyShortCode} title="Copy short code">
                                    <i className="bi bi-copy"></i>
                                </button>
                            </div>
                        </div>
                    </div>

                    <Links />
                    <CommentsTable clinicid={clinicId} />
                    <FeedbackTable clinicid={clinicId} />
                </div>
            )}
        </>
    );
}

export default ReputationTab;
